<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Doc — Ação: Editar rascunho
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Enquanto o documento está em
        strong  rascunho
        | , use
        strong  Editar rascunho
        |  para alterar os dados pelo mesmo wizard da emissão.

      .toast.toast-primary
        | Exige a permissão
        strong  Fiscalização → Documentos → Alterar
        |  e o documento precisa
        strong  permitir edição
        |  (ainda em rascunho).

      h5.h5 1. Abrir a ação
      ol
        li Abra o documento (
          strong Doc → Documentos → Exibir
          | ).
        li No rodapé, abra o menu
          strong  Ações
          | .
        li Clique na opção desejada (Editar rascunho).
      figure.manual-figure
        img(:src="imgMenu" alt="Menu Ações do documento")

      h5.h5 2. Wizard de edição
      figure.manual-figure
        img(:src="imgEdit" alt="Wizard Editar Documento")
      ol
        li Ajuste Informações, Irregularidades, Comentário, Textos etc.
        li Avance até
          strong  Confirmar
          |  e salve as alterações.
      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgMenu: require("@/assets/manuais/14-doc-acoes-menu.png"),
      imgEdit: require("@/assets/manuais/14a-doc-acao-editar-rascunho.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
